<template>
  <div
    v-if="!isLocatorStoreTakeawayDineInAvailabilityApiInProgress"
    class="col-sm-12 flex-column gap10"
  >
    <div
      class="store-status pt16 pb16 flex-row mb16"
      v-if="!storeOnline && !currentLocationUnservicable"
    >
      <div class="icon-container">
        <i class="jfi-info-line fs-22 lh22"></i>
      </div>
      <div>
        <p class="bold fs-14 lh20">{{ storeOfflineTitle }}</p>
        <p
          class="fs-12 lh18"
          @click="takeawayOrDineinClick($event)"
          v-html="storeOfflineDetails"
        ></p>
      </div>
    </div>
    <div
      class="store-status pt16 pb16 flex-row mb16"
      v-if="!storeOnline && currentLocationUnservicable"
    >
      <div class="icon-container">
        <i class="jfi-info-line fs-22 lh22"></i>
      </div>
      <div>
        <p class="bold fs-14 lh20">Sorry! We do not deliver to your location</p>
      </div>
    </div>
  </div>
</template>

<script>
import { staticImgBaseUrl, v2PwaBasePath } from "../config/apiEndpoints";
import Utility from "../helpers/utility";
import LocalStorageFunc from "../helpers/localStorageFunc";
import localStorageFunc from "../helpers/localStorageFunc";
import setEvents from "../helpers/events";
import Location from "../config/location";

export default {
  name: "StoreStatus",

  components: {},

  data() {
    return {
      staticImgBaseUrl: staticImgBaseUrl,
      hideCurrentLocationMessage: false,
      dineInAvailable: false,
      takeawayAvailable: false,
    };
  },

  mounted() {},

  updated() {
    this.logDialogueOrOODAEvent();
  },
  methods: {
    logDialogueOrOODAEvent(clicked, optionType) {
      let eventName = "";
      if (!this.currentLocationUnservicable && !this.storeOnline) {
        eventName = clicked ? "Dialogue_click" : "Dialogue";
      } else if (this.currentLocationUnservicable) {
        eventName = clicked ? "nghOODAClick" : "nghOODA";
      }
      let preEventObj = {};
      if (
        !clicked &&
        (this.isLocatorStoreTakeawayDineInAvailabilityApiInProgress ||
          eventName === "" ||
          LocalStorageFunc.getStoreIdOfLastStoreStatusEvent() ===
            LocalStorageFunc.storeId())
      )
        return;
      LocalStorageFunc.setStoreIdOfLastStoreStatusEvent(
        LocalStorageFunc.storeId()
      );
      if (eventName.includes("Dialogue")) {
        preEventObj = {
          eventLabel: this.storeOfflineTitle,
          category: "store offline",
          subCategory:
            this.dineInAvailable && this.takeawayAvailable
              ? "dine-in or takeaway"
              : this.dineInAvailable
              ? "dine-in"
              : this.takeawayAvailable
              ? "takeaway"
              : "no-option",
          locationType: this.locationType,
          hourType: this.hourType,
        };
        if (clicked) {
          preEventObj.optionType = optionType;
        }
      } else {
        preEventObj = {
          category: "Your current location is unservicable",
          subCategory:
            this.currentLocationUnservicable && !this.storeOnline
              ? "no-option"
              : this.currentLocationUnservicable
              ? "Use current location anyway"
              : this.dineInAvailable && this.takeawayAvailable
              ? "dine-in or takeaway"
              : this.dineInAvailable
              ? "dine-in"
              : this.takeawayAvailable
              ? "takeaway"
              : "no-option",
          locationType: this.locationType,
        };
        if (clicked) {
          preEventObj = {
            ...preEventObj,
            optionType,
          };
        } else {
          this.logUnserviceableEvent();
          preEventObj = {
            ...preEventObj,
            oodaType: this.oodaType,
            hourType: "ooda",
          };
        }
      }
      const eventObj = Utility.amplitudeEventObj(
        eventName,
        "location warning",
        3,
        preEventObj
      );
      setEvents("amplitude", eventName, eventObj);
    },
    logUnserviceableEvent() {
      const preEventObj = {
        category: "Unserviceable",
        eventAction: "nearby stores",
        eventLabel: "nextgen home",
        menuType: this.menuType,
        previousSetStore:
          typeof localStorageFunc.getPreviousStoreId() === "number" ? 1 : 0,
      };
      const eventObj = Utility.amplitudeEventObj(
        "Unserviceable_Events",
        undefined,
        undefined,
        preEventObj
      );
      setEvents("amplitude", "Unserviceable_Events", eventObj);
    },
    isCurrentTimeBefore(timeValue) {
      const currentTime = new Date();
      const tempDate =
        currentTime.getMonth() +
        1 +
        "/" +
        currentTime.getDate() +
        "/" +
        currentTime.getFullYear() +
        " " +
        timeValue;
      const timeToCheck = new Date(tempDate);
      return currentTime < timeToCheck;
    },
    isCurrentTimeAfter(timeValue) {
      const currentTime = new Date();
      const tempDate =
        currentTime.getMonth() +
        1 +
        "/" +
        currentTime.getDate() +
        "/" +
        currentTime.getFullYear() +
        " " +
        timeValue;
      const timeToCheck = new Date(tempDate);
      return currentTime > timeToCheck;
    },
    takeawayOrDineinClick(event) {
      const targetElement = event.target;
      if (targetElement.tagName === "A") {
        const optionType = targetElement.dataset["optiontype"];
        this.logDialogueOrOODAEvent(true, optionType);
      }
    },
  },
  computed: {
    currentOrderType() {
      return this.$store.state.User.currentOrderType;
    },
    isLoggedIn() {
      return this.$store.state.Auth.isLoggedIn;
    },
    storeOnline() {
      let _ = this.$store.state.Location.storeDetails.online;
      return _;
    },
    currentLocationUnservicable() {
      return this.$store.state.Location.currentLocationUnservicable;
    },
    locationData() {
      return this.$store.state.Location.locationData;
    },
    storeOfflineDetails() {
      let __ = this.$store.state.Location.storeDetails.online;
      let _ = this.$store.state.Location.takeawayDineAvailability;

      let redirectUrl = Utility.takeawayDineinFolder(
        this.isTrueLocationDetected
      );
      if (LocalStorageFunc.getLocationSource() != "ip") {
        redirectUrl = `${window?._siteProps_?.props?.postorderUIBasepath}nearestStore`;
      }

      let takeawayHref = `${v2PwaBasePath}/${redirectUrl}?deliveryType=P`;
      let dineHref = `${v2PwaBasePath}/${redirectUrl}?deliveryType=DINEIN`;
      let appDownloadLink = Utility.getAppDownloadLink();
      let advanceOrderApplicable =
        this.$store.state.Location.storeDetails.startTime
          .advanceOrderApplicable;

      if (LocalStorageFunc.getDeliveryType() != "D") {
        return `Please try again after sometime`;
      }

      if (_.TAKEAWAY && _.DINEIN) {
        this.takeawayAvailable = true;
        this.dineInAvailable = true;
        if (advanceOrderApplicable)
          return `To place an advance order <a data-optiontype="download app" href='${appDownloadLink}'>Download App</a> or choose <span><a data-optiontype="takeaway" href='${takeawayHref}'>Takeaway</a></span> or <span><a data-optiontype="dine-in" href='${dineHref}'>Dine-in</a></span>`;
        else
          return `Please try again after sometime or choose <span><a data-optiontype="takeaway" href='${takeawayHref}'>Takeaway</a></span> or <span><a data-optiontype="dine-in" href='${dineHref}'>Dine-in</a></span>`;
      } else if (_.TAKEAWAY) {
        this.takeawayAvailable = true;
        if (advanceOrderApplicable)
          return `To place an advance order <a data-optiontype="download app" href='${appDownloadLink}'>Download App</a> or choose <span><a data-optiontype="takeaway" href='${takeawayHref}'>Takeaway</a></span>`;
        else
          return `Please try again after sometime or choose <span><a data-optiontype="takeaway" href='${takeawayHref}'>Takeaway</a></span>`;
      } else if (_.DINEIN) {
        this.dineInAvailable = true;
        if (advanceOrderApplicable)
          return `To place an advance order <a data-optiontype="download app" href='${appDownloadLink}'>Download App</a> or choose <span><a data-optiontype="dine-in" href='${dineHref}'>Dine-in</a></span>`;
        else
          return `Please try again after sometime or choose <span><a data-optiontype="dine-in" href='${dineHref}'>Dine-in</a></span>`;
      } else {
        if (advanceOrderApplicable)
          return `To place an advance order <a data-optiontype="download app" href='${appDownloadLink}'>Download App</a>`;
        else return `Please try again after sometime`;
      }
    },
    isTrueLocationDetected() {
      return this.$store.state.Location.isTrueLocationDetected;
    },
    storeOfflineTitle() {
      let advanceOrderApplicable =
        this.$store.state.Location.storeDetails.startTime
          .advanceOrderApplicable;

      if (advanceOrderApplicable) {
        return `Store opens at ${
          (this.$store.state.Location.storeDetails.startTime.hour || "00") +
          ":" +
          (this.$store.state.Location.storeDetails.startTime.minute || "00")
        } ${this.$store.state.Location.storeDetails.startTime.amOrPm}`;
      } else {
        return "Sorry, Store is currently Offline";
      }
    },
    locationType() {
      return this.$store.state.Location.locationType;
    },
    hourType() {
      const storeStartTime =
        this.$store.state.Location.storeDetails?.storeOperationalStartTime;
      const storeEndTime =
        this.$store.state.Location.storeDetails?.storeOperationalEndTime;
      let hourType = "outside serviceable";
      if (storeStartTime && storeEndTime) {
        if (
          this.isCurrentTimeAfter(storeStartTime) &&
          this.isCurrentTimeBefore(storeEndTime)
        ) {
          hourType = "serviceable";
        }
      }
      return hourType;
    },
    oodaType() {
      return typeof localStorageFunc.getPreviousStoreId() === "number"
        ? "previous store"
        : "default store";
    },
    menuType() {
      const currentStoreId = localStorageFunc.storeId();
      if(this.currentLocationUnservicable) {
        return "previous location";
      }
      if (currentStoreId === Location.defaultStoreId) return "default location";
      return "current location";
    },
    isLocatorStoreTakeawayDineInAvailabilityApiInProgress() {
      return this.$store.state.Location
        .isLocatorStoreTakeawayDineInAvailabilityApiInProgress;
    },
  },
};
</script>

<style scoped></style>
